import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import Mission from '../components/Mission';
import FAQ from '../components/FAQ';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import InterestModal from '../components/InterestModal';

const HomePage = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Header onShowInterest={handleShowModal} />
      <Hero onShowInterest={handleShowModal} />
      <Features />
      <HowItWorks />
      <Testimonials onShowInterest={handleShowModal} />
      <Mission />
      <FAQ />
      <Newsletter />
      <Footer />
      <InterestModal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default HomePage;